import React from 'react'
import Testimonial, { ITestimonialCarousel } from '../Testimonial'
import ProductCarousel, { IProductCarousel } from '../ProductCarousel'
import { TCarouselMapper } from './types'

const CarouselMapper = (props: TCarouselMapper) => {
  const { slides } = props
  const type = slides[0]?.internal.type

  const carouselMap = new Map()
  carouselMap.set('ContentfulComponentTestimonialSlide', <Testimonial {...(props as ITestimonialCarousel)} />)
  carouselMap.set('ContentfulComponentProductSlide', <ProductCarousel {...(props as IProductCarousel)} />)
  carouselMap.set('ContentfulComponentContentModule', <ProductCarousel {...(props as IProductCarousel)} />)
  return (type && carouselMap.get(type)) || <></>
}

export default CarouselMapper
